import { useEffect, useState } from "react";
import ReceiptDialog from "./ReceiptDialog";
import { useAuth } from "../hooks/useAuth";
import { useUI } from "../providers/MoleUIContext";
import { useAppSocket } from "../providers/AppSocketContext";
import { Util } from "../util/Util";
import { canPrintReceipt } from '../util/access';
import { issueReceipt } from "../util/receiptPdf";
import { ReceiptOffer, registerReceiptPrompt } from "../util/receiptPrompt";

/**
 * App-wide receipt offer after a payment or wallet movement is recorded.
 * Follows UI_PRINT_RECEIPT like the POS: ALWAYS prints on the receipt
 * printer, PROMPT asks, NEVER stays quiet.
 */
const ReceiptPromptHost = () => {
	const { api, access } = useAuth();
	const { setLoadingMessage } = useUI();
	const { appSettings } = useAppSocket();
	const [offer, setOffer] = useState<ReceiptOffer | null>(null);

	useEffect(
		() =>
			registerReceiptPrompt((next) => {
				if (!canPrintReceipt(access)) return;
				const mode = appSettings?.UI_PRINT_RECEIPT?.value || "NEVER";
				if (Util.compareStrings(mode, "ALWAYS")) {
					void issueReceipt(api, next.source, "thermal", setLoadingMessage);
				} else if (Util.compareStrings(mode, "PROMPT")) {
					setOffer(next);
				}
			}),
		[api, access, appSettings, setLoadingMessage],
	);

	return <ReceiptDialog source={offer?.source ?? null} message={offer?.message} onClose={() => setOffer(null)} />;
};

export default ReceiptPromptHost;
